
import { useEffect } from 'react';
import { useVersion } from './useVersion';

// This hook will increment version when components mount
// indicating that changes have been made to the codebase
export const useAutoVersionIncrement = () => {
  const { incrementVersion } = useVersion();

  useEffect(() => {
    // Check if this is a development build or if changes were made
    const lastUpdate = localStorage.getItem('mdm-last-update');
    const currentTime = Date.now().toString();
    
    // If more than 1 second has passed since last update, increment version
    if (!lastUpdate || (parseInt(currentTime) - parseInt(lastUpdate)) > 1000) {
      incrementVersion();
      localStorage.setItem('mdm-last-update', currentTime);
    }
  }, [incrementVersion]);
};
